export default __webpack_public_path__ + "static/bg-1-e1e5db8daf9eff6fec8997a127bcf7bc.png";